export default "__VITE_ASSET__dae25147__"